"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hexToBuffer = void 0;
exports.hexToBuffer = function (value) { return Buffer.from(value.slice(2), "hex"); };
